"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Default submit button variant
var DEFAULT_SUBMIT_BUTTON_VARIANT = {
  priority: 'high'
};

//Submit button variant option
var SUBMIT_BUTTON_VARIANTS = {
  'Priority (High) - default': DEFAULT_SUBMIT_BUTTON_VARIANT,
  'Priority (Low)': {
    priority: 'low'
  },
  'Inverse (High)': {
    priority: 'high',
    inverse: true
  },
  'Inverse (Low)': {
    priority: 'low',
    inverse: true
  }
};
var spacingValue = 5;

//Default submit button size
var DEFAULT_SUBMIT_BUTTON_SIZE = {
  size: 'regular'
};

//Submit button size options
var SUBMIT_BUTTON_SIZES = {
  'Regular (Default)': DEFAULT_SUBMIT_BUTTON_SIZE,
  Small: {
    size: 'small'
  }
};
var SubmitButton = props => {
  var {
    submitForm = () => {},
    formMetaData = {}
  } = props;
  var submitButtonVariant = 'submitButtonVariant' in formMetaData && formMetaData.submitButtonVariant in SUBMIT_BUTTON_VARIANTS ? SUBMIT_BUTTON_VARIANTS[formMetaData.submitButtonVariant] : DEFAULT_SUBMIT_BUTTON_VARIANT;
  var submitButtonSize = 'submitButtonSize' in formMetaData && formMetaData.submitButtonSize in SUBMIT_BUTTON_SIZES ? SUBMIT_BUTTON_SIZES[formMetaData.submitButtonSize] : DEFAULT_SUBMIT_BUTTON_SIZE;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.Spacer, {
    space: spacingValue
  }), /*#__PURE__*/_react.default.createElement(_componentsWeb.Box, {
    key: "submit-button-box"
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.Button, {
    type: "submit",
    variant: _objectSpread(_objectSpread({}, submitButtonVariant), submitButtonSize),
    onPress: submitForm
  }, formMetaData.submitButtonLabel || 'Submit')));
};
SubmitButton.propTypes = {
  submitForm: _propTypes.default.func,
  formMetaData: _propTypes.default.object
};
var _default = exports.default = SubmitButton;